/* eslint-disable func-names */
import { getTrackProductData, productDataEnhance } from 'Utils/TrackingUtility'
import encryptData from './EncryptData'

/* eslint-disable */
function _submitTroughAjax(form) {
    var $form = $(form)
    var formData = $form.serializeArray()
    var helperInstance =
        $form.data('ytos-ctrl') || $form.closest('[data-ytos-ctrl]').data('ytos-ctrl')
    var formScope = this.getScope($form)

    const _innerSubmit = (formData) => {
        if (!formData || !this.validateForm(form) || $form.data('ytos-pending')) {
            return
        }

        yTos.notify('yTos::BeginAjaxRequest', { element: $form })
        yTos.notify('yTos::BeginAjaxFormRequest', { element: $form }, { scope: formScope })

        var absoluteUrl = yTos.getAbsoluteURL($form.attr('action'), yTos.isCORSSupported())

        $form.data('ytos-pending', true)

        yTos.ajax(absoluteUrl, {
            type: form.method,
            data: formData,
            xhrFields: {
                withCredentials: true,
            },
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            success: function (data) {
                var $form = $(this)
                $form.data('ytos-pending', false)
                var formData = $form.data()
                var successFn = formData.ytosFormSuccess
                if (helperInstance && typeof helperInstance[successFn] == 'function') {
                    // There was a callback
                    helperInstance[successFn](data)
                } else if (typeof successFn == 'string') {
                    // It was a message name to be notified
                    if (formData.ytosFormScope) {
                        var scope = helperInstance.scope
                        yTos.notify(successFn, data, { scope: scope })
                    } else {
                        yTos.notify(successFn, data)
                    }
                } else {
                    $(this).html($.trim(data))
                }

                yTos.notify('yTos::EndAjaxRequest', { element: $(this) })
                yTos.notify('yTos::EndAjaxFormRequest', { element: $(this) }, { scope: formScope })
            }.bind(form),
            error: function (helperInstance, data, textStatus, errorThrown) {
                var $form = $(this)
                $form.data('ytos-pending', false)
                var trimmedResponse = $($.trim(data.responseText))
                var errorFn = $form.data('ytos-form-error')

                var htmlToNotify = null

                if (trimmedResponse.find('form').length > 0) {
                    htmlToNotify = trimmedResponse.find('form').children()

                    $form.html(htmlToNotify)

                    var $ctrlEl = $form.closest('[data-ytos-ctrl]')

                    if ($ctrlEl.length > 0) {
                        yTos.helpers.destroyPlugins($ctrlEl, true)
                        yTos.helpers.initializeHelpers(yTos.domlib($ctrlEl), {
                            isAsyncronouslyLoaded: true,
                        })
                    }
                } else if (trimmedResponse.filter('form').length > 0) {
                    yTos.helpers.destroyPlugins($form, /* includeRoot */ false)
                    htmlToNotify = trimmedResponse.children()
                    $form.html(htmlToNotify)
                    yTos.helpers.initializeHelpers(yTos.domlib($form), {
                        isAsyncronouslyLoaded: true,
                    })
                } else {
                    htmlToNotify = trimmedResponse
                }

                if (
                    data.status === 403 &&
                    helperInstance &&
                    typeof helperInstance.refreshOnAntiforgeryException == 'function'
                ) {
                    helperInstance.refreshOnAntiforgeryException()
                }

                if (helperInstance && typeof helperInstance[errorFn] == 'function') {
                    //There was a callback
                    helperInstance[errorFn](htmlToNotify, data.status, errorThrown)
                } else if (errorFn) {
                    if ($(this).data().ytosFormScope) {
                        yTos.notify(errorFn, htmlToNotify, { scope: helperInstance.scope })
                    } else {
                        yTos.notify(errorFn, htmlToNotify)
                    }
                }

                var $accessibleValidationElm = $form.find('[data-ytos-validation-summary]')
                if ($accessibleValidationElm.length) {
                    yTos.focusElement($accessibleValidationElm.get(0))
                }

                yTos.notify('yTos::EndAjaxRequest', { element: $form })
                yTos.notify('yTos::EndAjaxFormRequest', { element: $form }, { scope: formScope })
            }.bind(form, helperInstance),
        })
    }

    if (
        helperInstance.name === 'account.registrationForm' ||
        helperInstance.name === 'account.editUserPasswordForm' ||
        helperInstance.name === 'account.recoveryPassword'
    ) {
        encryptData(formData, $form.data('sso-pubkey')).then(_innerSubmit)
    } else {
        _innerSubmit(formData)
    }
}
/* eslint-enable */

/* eslint-disable */
/**
 * @memberof yTos.helpers.UI.AjaxForm#
 * @param {Object} evt The event object
 * @fires yTos::AjaxForm::PasswordStrength
 */
function _passwordStrength(evt) {
    var $input = $(evt.currentTarget)
    var $inputContainer = $input.parents('[data-ytos-password-container]')
    var $inputPasswordStrengthContainer = $inputContainer.find('*[data-ytos-password-strength]')
    var password = $input.val()
    var minChars = 6
    var r = new RegExp(
        "^[\\-a-z0-9\\'\\^&\\*\\(\\)\\/#!_@%\\.\\$\\|\\?=\\\\]{" + minChars + ',15}$',
        'i'
    )
    var chosen = {
        strength: -1,
    }
    var passwordLevel = -1

    var strengthLevels = {
        weak: {
            strength: 0,
            regex: '(?=.{6,}).*',
        },
        medium: {
            strength: 1,
            regex: '^(?=.{6,})((?=.*[a-zA-Z])(?=.*[0-9])|(?=.*[a-zA-Z])(?=.*[\\W_])|(?=.*[0-9])(?=.*[\\W_])).*$',
        },
        strong: {
            strength: 2,
            regex: '^(?=.{6,})((?=.*[a-zA-Z])(?=.*[\\W_])(?=.*[0-9])).*$',
        },
    }

    if ($input.val().length <= minChars) {
        $inputPasswordStrengthContainer.find('*[data-ytos-password-level]').removeClass('selected')
        $Y.notify('yTos::AjaxForm::PasswordStrength', { level: '', strength: -1 })
    }

    if ($input.val().length >= minChars) {
        for (var lvl in strengthLevels) {
            if (strengthLevels.hasOwnProperty(lvl)) {
                if (new RegExp(strengthLevels[lvl].regex, 'g').test(password)) {
                    if (strengthLevels[lvl].strength > chosen.strength) {
                        chosen = strengthLevels[lvl]
                        passwordLevel = lvl
                    }
                }
            }
        }

        $inputPasswordStrengthContainer.find('*[data-ytos-password-level]').removeClass('selected')
        $inputPasswordStrengthContainer
            .find("[data-ytos-password-level='" + passwordLevel + "']")
            .addClass('selected')

        $Y.notify('yTos::AjaxForm::PasswordStrength', {
            level: passwordLevel,
            strength: chosen.strength,
        })
    }

    return r.test(password)
}
/* eslint-enable */

export default function yTosOverrides() {
	const originalFunction = yTos.debug.log
	// eslint-disable-next-line func-names
	yTos.debug.log = function (msg, level, style) {
		if (msg instanceof Error) {
			level = level ?? 'error'
		}
		originalFunction(msg, level, style)
	}

	yTos.watch({
		'yTos::HelperParsed::ui.ajaxForm': (helperClass) => {
			if (typeof helperClass !== 'function') return
			helperClass.prototype.passwordStrength = _passwordStrength
		},
	})

	yTos.watch({
		'yTos::HelperParsed::ui.scrollToError': (helperClass) => {
			if (typeof helperClass !== 'function') return
			helperClass.prototype.scrollToError = () => {}
			helperClass.prototype.isOnScreen = () => false
		},
	})

	if (yTos.Cartier.controllerName === 'Item') {
		yTos.watch({
			'yTos::HelperParsed::product.reserveInRetailStoreOpenLayerButton': (helperClass) => {
				if (typeof helperClass !== 'function') return

				helperClass.prototype.getPartialView = (partNumber) => {
					// CUSTOM INSERT POPUP
					yTos.Cartier.popup({
						cssClasses: ['size-base', 'reserveInRetailStoreOpenLayerButton'],
						contentURL: '/yTos/Plugins/ItemPlugin/RenderReserveInRetailStore',
						contentURLOptions: {
							data: {
								siteCode: yTos.navigation.SiteCode,
								partNumber,
								rectifiedPartNumberFallbackType: 1,
							},
						},
					})
				}
			},
			'yTos::HelperParsed::product.retailStoresList': (helperClass) => {
				if (typeof helperClass !== 'function') return
				// eslint-disable-next-line func-names
				helperClass.prototype.refresh = function (position) {
					// CUSTOM GET SELECTED PRODUCT
					this.model.getSelectedProduct().then((product) => {
						this.getHTML(
							{ Plugin: 'Item', Action: 'RenderRetailStoresListWithCoordsAsync' },
							{
								data: {
									siteCode: this.model.get('siteCode'),
									partNumber:
										// CUSTOM INSERT SKUPARTNUMBER
										product?.skuPartNumber ||
										this.model.get('landingColorPartNumber'),
									options: {
										ShowOpeningHours: this.options.showOpeningHours,
										GroupRetailStoresByCountry:
											this.options.groupRetailStoresByCountry,
										MapRenderType: this.options.mapRenderType,
									},
									latitude: position.coords.latitude,
									longitude: position.coords.longitude,
								},
								// eslint-disable-next-line func-names
								success: function () {
									this.checkAvailability()
									this.notify('yTos::Product::StoreListRefreshed')
								}.bind(this),
								// eslint-disable-next-line func-names
								error: function (response) {
									this.notify('yTos::Product::StoreListRefreshedError', {
										content: response,
									})
								}.bind(this),
								stripMe: true,
								autoUpdate: true,
							}
						)
					})
				}
			},
		})
	}

	if (yTos.Cartier.controllerName === 'Search') {
		yTos.watchOne({
			'yTos::HelperParsed::search.products': (helperClass) => {
				if (typeof helperClass !== 'function') return
				helperClass.prototype.initInfiniteScroll = () => {}
			},
		})
		yTos.watchOne({
			'yTos::HelperParsed::search.orderBy': (helperClass) => {
				if (typeof helperClass !== 'function') return
				// eslint-disable-next-line func-names
				helperClass.prototype.initialize = function () {
					this.model = yTos.models.Searches({ scope: 'mainSearch' })
					this.updateDOM()
				}
			},
		})
	}

	if (
		(yTos.navigation.Controller === 'User' && yTos.navigation.Action === 'Register') ||
		(yTos.navigation.Controller === 'User' && yTos.navigation.Action === 'Profile') ||
		yTos.navigation.Controller === 'PasswordRecovery'
	) {
		yTos.watchOne({
			'yTos::HelperParsed::ui.ajaxForm': (helperClass) => {
				if (typeof helperClass !== 'function') return
				helperClass.prototype.submitTroughAjax = _submitTroughAjax
			},
		})
	}

	yTos.watch({
		'yTos::HelperLoaded::ui.radioGroup': (helperInstance) => {
			const classInstance = helperInstance.$el[0]
			const checkedRadioGroup = classInstance?.querySelectorAll(
				'[data-ytos-input="radiobutton"]:checked'
			)

			if (!checkedRadioGroup) return
			;[...checkedRadioGroup].forEach((singleCheckbox) => {
				const selectedValue = singleCheckbox.value

				const inputContainer = singleCheckbox.closest('[data-ytos-input-container]')

				if (inputContainer) {
					inputContainer.querySelector('[data-ytos-radiogroup-value]').value =
						selectedValue
				}
			})
		},
	})

	/* eslint-disable */
    if (yTos.Cartier.controllerName === 'confirmation') {
        yTos.watch({
            'yTos::HelperParsed::common.addressHint': (helperClass) => {
                if (typeof helperClass !== 'function') return

                helperClass.prototype.initialize = function (partNumber) {
                    const countryEnabled = [this.options.isoCode.toLowerCase()]

                    if (this.options.isoCode.toLowerCase() === 'ch') {
                        countryEnabled.push('li')
                    }

                    this.settings = {
                        types: ['geocode'],
                        componentRestrictions: this.options.isoCode
                            ? { country: countryEnabled }
                            : [],
                        addressHintLabels: $Y.safeGet(
                            yTos,
                            'configuration.addressAutocomplete.addressHintLabels'
                        ),
                        sessionToken: new google.maps.places.AutocompleteSessionToken(),
                    }

                    const inputField = this.$('[data-ytos-autocomplete-target]').get(0)

                    if (this.options.isoCode && this.settings.addressHintLabels) {
                        this.replaceLabels(
                            [
                                this.$el.find('[data-ytos-address-example]'),
                                this.$el.siblings('[data-ytos-address-example]'),
                            ],
                            this.options.isoCode.toLowerCase(),
                            this.settings.addressHintLabels
                        )
                    }

                    this.autocomplete = new google.maps.places.Autocomplete(
                        inputField,
                        this.settings
                    )
                    this.autocomplete.setFields(['address_components'])
                    this.autocomplete.addListener('place_changed', this.notifyHints.bind(this))
                    this.autocompleteService = new google.maps.places.AutocompleteService()

                    this.inputFieldAddress = $(document)
                        .find('[data-ytos-autocomplete-target *= "street_number"]')
                        .get(0)
                    $(this.inputFieldAddress).on('blur', this.onBlurCheckAddress.bind(this))
                }
            },
        })
    }


    yTos.watch({
        'yTos::HelperParsed::addressbook.addressList': (helper) => {
            if (!helper.prototype.globalMessages) {
                helper.prototype.globalMessages = {}
            }

            helper.prototype.globalMessages['yTos::Checkout::SetPaymentMethodSuccess'] = 'update'
        },
    })
    yTos.watch({
        'yTos::HelperParsed::checkout.editItemQuantity': (helper) => {
            if (typeof helper !== 'function') return
            helper.prototype.increaseItemQuantity = function (event) {
                if ($(event.currentTarget).data('ytosIncrease') === 'disabled') {
                    return
                }

                this.postHTML('/yTos/Plugins/CheckoutPlugin/IncreaseQuantityAsync', {
                    data: this.options,
                    success: function ($response) {
                        // handleCheckoutWarnings() is provided by ui.checkoutWarnings
                        this.handleCheckoutWarnings($response, async (operationResult) => {
                            this.notify('yTos::Checkout::ItemQuantityUpdated', {
                                type: 'increased',
                                code10: this.options.code10,
                                sizeId: this.options.sizeId,
                            })
                            const orderItemIds =
                                $response.data('ytos-operation-result').OrderItemIds
                            this.notify(
                                'yTos::Checkout::IncreaseQuantitySuccess',
                                {
                                    $el: $response,
                                    hasWarning: operationResult.hasWarning,
                                    dataCart: orderItemIds,
                                },
                                { scope: this.scope }
                            )

                            const trackObject = await getTrackProductData(this.options.code10)
                            const trackObjectEnhanced = Object.assign(
                                {},
                                productDataEnhance(trackObject),
                                { skuMfPartNumber: this.options.skuMfPartNumber }
                            )

                            this.notify(
                                'yTos::Tracking::IncreaseQuantitySuccess',
                                { trackInfo: trackObjectEnhanced },
                                { scope: this.scope }
                            )
                        })
                    }.bind(this),
                    error: function ($response) {
                        this.notify(
                            'yTos::Checkout::IncreaseQuantityError',
                            { $el: $response },
                            { scope: this.scope }
                        )
                    }.bind(this),
                    stripMe: true,
                    autoUpdate: true,
                    preventUpdateOnError: true,
                })
            }
        },
        'yTos::HelperParsed::checkout.removeItem': (helper) => {
            helper.prototype.removeItem = function () {
                this.disableButton()
                // remove all the items with a given code10/size combination
                this.postHTML('/yTos/Plugins/CheckoutPlugin/RemoveItemAsync', {
                    data: this.options,
                    success: function ($response) {
                        this.enableButton()
                        // handleCheckoutWarnings() is provided by ui.checkoutWarnings
                        this.handleCheckoutWarnings($response, async () => {
                            const trackObject = await getTrackProductData(this.options.code10)
                            const trackObjectEnhanced = Object.assign(
                                {},
                                productDataEnhance(trackObject),
                                { skuMfPartNumber: this.options.skuMfPartNumber }
                            )
                            this.notify(
                                'yTos::Tracking::ProductRemovedToShoppingBag',
                                { trackInfo: trackObjectEnhanced },
                                { scope: this.scope }
                            )

                            this.notify('yTos::Checkout::RemoveItemSuccess', {
                                html: $response,
                            })
                        })
                    }.bind(this),
                    error: function ($response) {
                        this.enableButton()
                        this.notify('yTos::Checkout::RemoveItemError', { html: $response })
                    }.bind(this),
                })
            }
        },
    })

    yTos.watch({
        'yTos::HelperParsed::product.toggleProductInWishlist': (helper) => {
            helper.prototype.toggleProductInGuestWishlist = function (partNumber) {
                const guestWishlistManager = yTos.safeGet(yTos, 'helpers.Common.GuestWishListManager');

                return this.model
                    .getColorPartNumber(this.model.get('selectedColor'))
                    .then(
                        function (colorPartNumber) {
                            if (!colorPartNumber) {
                                colorPartNumber = this.options.selectedColorPartNumber;
                            }
                            try {

                                this.notifyTrackingEvent(colorPartNumber, partNumber);
                                const alreadyInWhislist = guestWishlistManager.isItemAlreadyAddedToGuestWishList(partNumber);

                                const updatedGuestWishList = guestWishlistManager.toggle(
                                    colorPartNumber,
                                    partNumber,
                                    this.model.get('siteCode'),
                                    this.options.guestWishListMaxItems
                                );

                                this.notify('yTos::Product::WishlistUpdatedByToggle', {
                                    colorPartNumber: colorPartNumber,
                                    partNumber: partNumber,
                                });

                                if (alreadyInWhislist) {
                                    this.notify('CAR::Product::ProductRemovedFromWishlist', { skuPartNumber: partNumber, colorPartNumber: colorPartNumber });
                                } else {
                                    this.notify('CAR::Product::ProductAddedToWishlist', { skuPartNumber: partNumber, colorPartNumber: colorPartNumber });
                                    this.notify('CAR::Product::ProductAddedToWishlist', { skuPartNumber: partNumber, colorPartNumber: colorPartNumber }, { scope: partNumber});
                                }

                                return updatedGuestWishList;
                            } catch (error) {
                                this.notify(
                                    'yTos::Product::AddProductToWishlistError',
                                    {
                                        content: "<span class=\"layer-title\">" + yTos.Cartier.labels.warningLabels + "</span> " + "<span>" + this.options.wishListFullErrorLabel + "</span>",
                                        partNumber: partNumber,
                                        statusCode: 403,
                                    },
                                    { scope: this.scope }
                                );
                                return guestWishlistManager.retrieveGuestWishListFromLocalStorage();
                            }
                        }.bind(this)
                    );
            }

            helper.prototype.addProductInWishlist = function (partNumber) {
                this.disableButton();

                return this.postHTML(
                    { Plugin: 'Item', Action: 'AddProductToWishListForToggle' },
                    {
                        data: {
                            partNumber: partNumber,
                            wishlistId: helper.wishlistId,
                        },
                    }
                ).then(
                    function () {
                        this.enableButton();

                        this.notify('yTos::Product::ProductAddedToWishlist', {
                            skuPartNumber: partNumber,
                        });
                        this.notify('CAR::Product::ProductAddedToWishlist', {
                            skuPartNumber: partNumber,
                        }, { scope: this.scope });

                        this.notify('yTos::Tracking::ItemAddedToWishlist', {
                            size: this.model.get('selectedSize'),
                            color: this.model.get('selectedColor'),
                            partNumber: partNumber,
                        });

                        return helper.wishlist.then(function (wishlist) {
                            wishlist.push(partNumber);
                            return wishlist;
                        });
                    }.bind(this)
                ).catch(
                    function (error) {
                        this.enableButton();
                        const $response = $($Y.trim(error.responseText));
                        const errorKey = $response.data('ytosErrorkey');

                        this.notify(
                            'yTos::Product::AddProductToWishlistError',
                            {
                                content: $response,
                                statusCode: error.status,
                                errorKey: errorKey,
                            },
                            { scope: this.scope }
                        );
                        this.notify('yTos::Tracking::ItemAddedToWishlistError', {
                            size: this.model.get('selectedSize'),
                            color: this.model.get('selectedColor'),
                            partNumber: partNumber,
                        });

                        return helper.wishlist;
                    }.bind(this)
                );
            }

            helper.prototype.getPartNumbersToCheck = function (colorIdentifier, sizeIdentifier) {
                if (colorIdentifier && sizeIdentifier) {
                    return this.model
                        .getProduct(colorIdentifier, sizeIdentifier)
                        .then(function (modelProduct) {
                            const isItemOneSize = modelProduct.productSize.identifier === 'OneSize';
                            if (isItemOneSize) {
                                return [
                                    modelProduct.colorPartNumber,
                                    modelProduct.skuPartNumber
                                ];
                            }
                            return [modelProduct.skuPartNumber];
                        });
                }

                if (colorIdentifier) {
                    return this.model.getColorPartNumber(colorIdentifier).then(
                        function (selectedColorPartNumber) {
                            if (!selectedColorPartNumber) {
                                return Promise.resolve(
                                    [this.options.selectedColorPartNumber].concat(
                                        this.options.colors[this.options.selectedColorPartNumber]
                                    )
                                );
                            }
                            return [selectedColorPartNumber].concat(
                                this.options.colors[selectedColorPartNumber]
                            );
                        }.bind(this)
                    );
                }

                return Promise.resolve(
                    [this.options.selectedColorPartNumber].concat(
                        this.options.colors[this.options.selectedColorPartNumber]
                    )
                );
            }

            helper.prototype.getPartNumberToSend = function (colorIdentifier, sizeIdentifier) {
                if (colorIdentifier && sizeIdentifier) {
                    return this.model.getSkuPartNumber(colorIdentifier, sizeIdentifier);
                }

                if (colorIdentifier) {
                    return this.model.getColorPartNumber(colorIdentifier).then(
                        function (selectedColorPartNumber) {
                            if (!selectedColorPartNumber) {
                                return Promise.resolve(
                                    this.options.selectedColorPartNumber
                                );
                            }
                            return selectedColorPartNumber
                        }.bind(this)
                    );
                }

                return Promise.resolve(this.options.selectedColorPartNumber);
            }
        },
        'yTos::HelperParsed::wishlist.shareWishlistLinkButton': (helper) => {
            helper.prototype.defaults = {
                confirmLayer: {
                    closeOnProceed: true,
                    modal: false,
                    query: {},
                    scope: 'share-wishlist-link',
                },
            }
            helper.prototype.onLayerOpen = function (layerData) {
                if (!layerData || !layerData.content) {
                    return;
                }
                const $input = layerData.content.find('input[name=sharedWishlistLink]');
                if ($input.length === 0) {
                    return;
                }
                $input.on('copy', () => this.tryMarkWishListAsPublic($input));
            }
        },
    })
    /* eslint-enable */
}
